import images from "../../../images";

const gamesList = [
    {
        title: "your ai slop bores me",
        subtitle: "A real-time multiplayer game where humans role-play as AI.",
        thumbnail: images.aislop.url,
        url: "https://youraislopbores.me//"
    },
    
    {
        title: "Infinite Craft",
        subtitle: "A crafting game where you can make anything.",
        thumbnail: images.infiniteCraft.url,
        url: "https://neal.fun/infinite-craft/"
    },
    {
        title: "Stimulation Clicker",
        subtitle: "Stimulation Clicker is a clicker game that will stimulate your senses.",
        thumbnail: images.stimulationClicker.url,
        url: "https://neal.fun/stimulation-clicker/"
    },
    {
        title: "Solitaired",
        subtitle: "Online solitaire.",
        thumbnail: images.solitaired.url,
        url: "https://solitaired.com/"
    },
    {
        title: "Wordle",
        subtitle: "NYT Wordle",
        thumbnail: images.wordle.url,
        url: "https://www.nytimes.com/games/wordle/index.html"
    },
    {
        title: "The Ratchelor",
        subtitle: "Play as The Ratchelor, an eligible single rat looking for love.",
        thumbnail: images.ratchelor.url,
        url: "https://algorat.itch.io/the-ratchelor-a-rat-dating-sim"
    },
    {
        title: "Penultima",
        subtitle: "Short visual novel about guys in a mecha. Gorgeous art",
        thumbnail: images.penultima.url,
        url: "https://zetareishi.itch.io/penultima"
    }



]

export default gamesList;